import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { CiterneAffectation } from '@/types';

interface AffectationState {
  affectations: CiterneAffectation[];
  pageNum: number;
  totalPages: number;
}

const initialState: AffectationState = { affectations: [], pageNum: 0, totalPages: 0 };

const affectationSlice = createSlice({
  name: 'affectation',
  initialState,
  reducers: {
    setAffectations(state, action: PayloadAction<{ data: CiterneAffectation[]; pageNum?: number; totalPages?: number }>) {
      console.log('setAffectations', action.payload);
      state.affectations = action.payload.data ?? [];
      if (action.payload.pageNum != null) state.pageNum = action.payload.pageNum;
      if (action.payload.totalPages != null) state.totalPages = action.payload.totalPages;
    },
    addAffectation(state, action: PayloadAction<CiterneAffectation>) {
      state.affectations.push(action.payload);
    },
    removeAffectation(state, action: PayloadAction<CiterneAffectation>) {
      state.affectations = state.affectations.filter((a) => a.id !== action.payload.id);
    },
    editAffectation(state, action: PayloadAction<CiterneAffectation>) {
      const i = state.affectations.findIndex((a) => a.id === action.payload.id);
      if (i !== -1) state.affectations[i] = action.payload;
    },
  },
});

export const { setAffectations, addAffectation, removeAffectation, editAffectation } = affectationSlice.actions;
export default affectationSlice.reducer;
